/** --------------------------------------------------
*
*   pages - overview page
*   OVERVIEW PAGE BANNER VIDEO
*
*  -------------------------------------------------- */

(($, Drupal, duo) => {
  Drupal.behaviors.overview_page_banner_video = {
    attach: function(context, settings) {
      const self = this;

      // only do the following once:
      $(document, context).once('overview_page_banner_video').each(function() {
        self.init(context, settings);
      });
    },

    init: function(context, settings) {

      // setup fancybox:
      $('.js-overview-page-banner-video-link').fancybox({
        loop: true,
        keyboard: true,
        arrows: true,
        infobar: false,
        toolbar: false,
        buttons: [],
        smallBtn: true,
        idleTime : 30,
        wheel: false,
        clickOutside: 'close',
        clickContent: false,
        animationEffect: 'fade',
        animationDuration: 500,
        transitionEffect: 'fade',
        transitionDuration: 366,
        media : {
          youtube : {
            params : {
              autoplay : 1,
              showinfo: 0
            }
          }
        },
        mobile : {
          clickSlide : function( current, event ) {
            return current.type === 'image' ? 'close' : 'close';
          },
          clickContent : function( current, event ) {
            return current.type === 'image' ? 'close' : 'close';
          },
        }
      });
    }
  };
})(jQuery, Drupal, window.duo = window.duo || {});
